export default __webpack_public_path__ + "static/media/personal-setting.a4e9e9de.svg";